import { PlanInputSchema } from '@weft/types';
import type { oz } from '@weft/utils';

export const UpdatePlanRequestSchema = PlanInputSchema.openapi('UpdatePlanRequest');

export type UpdatePlanRequestPayload = oz.infer<typeof UpdatePlanRequestSchema>;